import { UniversalSystemPageRequestType } from 'store/storeTypes';
import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { makeApiUrl } from './_shared/utils';
import apiAction from './_shared/apiAction';
import { getRealTimeHeaders } from './_shared/realTimeHeaders';
import { authService } from 'services/AuthProvider';
import { getCustomSearchParameters } from 'helpers/date';

export const toggleSwPopUp = createStandardAction('TOGGLE_SOFTWARE_VERSION_POPOVER')<{
  isOpen: boolean;
}>();
export const setSelectedPrinter = createStandardAction('SET_SELECTED_PRINTER')<{ printer }>();
export const setSerialGkNumberForSoftwareVersion = createStandardAction(
  'SET_SERIAL_NUMBER_FOR_SOFTWARE_VERSION'
)<{
  systemSerialGk: string;
}>();

export const getSoftwareVersionsAC = createAsyncAction(
  'SOFTWARE_VERSIONS_REQUEST_STARTED',
  'SOFTWARE_VERSIONS_REQUEST_SUCCESS',
  'SOFTWARE_VERSIONS_REQUEST_FAILED'
)<UniversalSystemPageRequestType, any, Error>();

export const getSoftwareVersionsRequest = (
  { day, week, custom, systemGroup, system, isSilent }: UniversalSystemPageRequestType,
  isRealTime: boolean = false
) => {
  const url = makeApiUrl('/api/system-page-report/software-versions');
const customTimeframeParameters = getCustomSearchParameters(custom);
    return apiAction({
      request: {
        url,
        headers: getRealTimeHeaders(isRealTime),
        params: {
          day,
          week,
          custom: customTimeframeParameters,
          systemGroup,
          system,
        },
      },
      logic: {
        onFailed: (error, dispatch) => {
          dispatch(
            getSoftwareVersionsAC.failure({
              name: error.name,
              message: error.message,
            })
          );
        },
        onStarted: dispatch => {
          dispatch(getSoftwareVersionsAC.request({ day, week, systemGroup, system, isSilent }));
        },
        onSuccess: (data, dispatch) => {
          dispatch(getSoftwareVersionsAC.success(data));
        },
      },
    });
};


